import {
	HttpClient,
	provideHttpClient,
	withInterceptorsFromDi
}                                                       from '@angular/common/http';
import {
	APP_INITIALIZER,
	NgModule
}                                                       from '@angular/core';
import { BrowserModule }                                from '@angular/platform-browser';
import { BrowserAnimationsModule }                      from '@angular/platform-browser/animations';
import { AppCoreModule }                                from '@app/core/app-core.module';
import { SharedModule }                                 from '@app/shared/shared.module';
import { APP_CONFIG }                                   from '@appConfig/_app-config_master';
import { LANGUAGE_CONFIG }                              from '@appConfig/language-config';
import {
	ANALYTICS_CONFIG,
	MATOMO_TRACKER_URL_BY_ENVIRONMENT
}                                                       from '@core/analytics/config/analytics-config';
import { TranslationHelperService }                     from '@core/services/translation-helper.service';
import { environment }                                  from '@env/environment';
import { NgbModule }                                    from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule }                                from '@ngrx/effects';
import { StoreModule }                                  from '@ngrx/store';
import {
	MissingTranslationHandler,
	TranslateLoader,
	TranslateModule
}                                                       from '@ngx-translate/core';
import { TranslateHttpLoader }                          from '@ngx-translate/http-loader';
import {
	ApiModule as ManagementAdminApiModule,
	BASE_PATH as BASE_PATH_ADMIN_MANAGEMENT
}                                                       from '@openApiGenerated/admin-api';
import {
	ApiModule as AdminUsageApiModule,
	BASE_PATH as BASE_PATH_ADMIN_USAGE
}                                                       from '@openApiGenerated/admin-usage-api';
import {
	ApiModule as ArchivingApiModule,
	BASE_PATH as BASE_PATH_ARCHIVING
}                                                       from '@openApiGenerated/archiving-api';
import {
	ApiModule as ArchivingExportApiModule,
	BASE_PATH as BASE_PATH_ARCHIVING_EXPORT
}                                                       from '@openApiGenerated/archiving-export-api';
import {
	ApiModule as ArchivingUsageAdminApiModule,
	BASE_PATH as BASE_PATH_ARCHIVING_USAGE_ADMIN
}                                                       from '@openApiGenerated/archiving-usage-admin-api';
import {
	ApiModule as ArchivingUsageApiModule,
	BASE_PATH as BASE_PATH_ARCHIVING_USAGE
}                                                       from '@openApiGenerated/archiving-usage-api';
import {
	ApiModule as ArchivingUserManagementApiModule,
	BASE_PATH as BASE_PATH_ARCHIVING_USER_MANAGEMENT
}                                                       from '@openApiGenerated/archiving-user-management-api';
import {
	ApiModule as AuditEventApiModule,
	BASE_PATH as BASE_PATH_AUDIT_EVENT
}                                                       from '@openApiGenerated/audit-event-api';
import {
	ApiModule as EricAdminApiModule,
	BASE_PATH as BASE_PATH_ERIC_ADMIN
}                                                       from '@openApiGenerated/eric-wrapper-admin-api';
import {
	ApiModule as EricApiModule,
	BASE_PATH as BASE_PATH_ERIC
}                                                       from '@openApiGenerated/eric-wrapper-api';
import {
	ApiModule as ExportApiModule,
	BASE_PATH as BASE_PATH_EXPORT
}                                                       from '@openApiGenerated/export-api';
import {
	ApiModule as FiskalTssLogAdminApiModule,
	BASE_PATH as BASE_PATH_FISKAL_ADMIN
}                                                       from '@openApiGenerated/fiskal-tss-log-admin-api';
import {
	ApiModule as FiskalTssLogExportApiModule,
	BASE_PATH as BASE_PATH_FISKAL_EXPORT
}                                                       from '@openApiGenerated/fiskal-tss-log-export-api';
import {
	ApiModule as ImportApiModule,
	BASE_PATH as BASE_PATH_IMPORT
}                                                       from '@openApiGenerated/import-api';
import {
	ApiModule as ManagementApiModule,
	BASE_PATH as BASE_PATH_MANAGEMENT
}                                                       from '@openApiGenerated/management-api';
import {
	ApiModule as NotificationAdminApiModule,
	BASE_PATH as BASE_PATH_NOTIFICATION_ADMIN
}                                                       from '@openApiGenerated/notification-admin-api';
import {
	ApiModule as NotificationApiModule,
	BASE_PATH as BASE_PATH_NOTIFICATION
}                                                       from '@openApiGenerated/notification-api';
import {
	ApiModule as SelfcareApiModule,
	BASE_PATH as BASE_PATH_SELFCARE
}                                                       from '@openApiGenerated/selfcare-api';
import {
	ApiModule as StatisticsApiModule,
	BASE_PATH as BASE_PATH_STATISTICS
}                                                       from '@openApiGenerated/statistics-api';
import {
	ApiModule as UsageApiModule,
	BASE_PATH as BASE_PATH_USAGE
}                                                       from '@openApiGenerated/usage-api';
import { BASE_PATH as BASE_PATH_USER_MANAGEMENT_ADMIN } from '@openApiGenerated/user-management-admin-api';
import {
	ApiModule as UserManagementApiModule,
	BASE_PATH as BASE_PATH_USER_MANAGEMENT
}                                                       from '@openApiGenerated/user-management-api';
import { KeycloakUtils }                                from '@utils/helpers';
import {
	KeycloakAngularModule,
	KeycloakService
}                                                       from 'keycloak-angular';
import {
	LoggerModule,
	NgxLoggerLevel
}                                                       from 'ngx-logger';
import { MatomoModule }                                 from 'ngx-matomo-client';
import { ToastrModule }                                 from 'ngx-toastr';
import { AppRoutingModule }                             from './app-routing.module';
import { AppComponent }                                 from './app.component';


export function createTranslateLoader( http: HttpClient ) {
	return new TranslateHttpLoader( http, LANGUAGE_CONFIG.languagesPath, '.json' );
}

@NgModule( {
	declarations: [
		AppComponent
	],
	bootstrap: [
		AppComponent
	],
	imports: [
		AppCoreModule, // must be imported first
		// OpenApi Modules
		AdminUsageApiModule,
		ArchivingApiModule,
		ArchivingExportApiModule,
		ArchivingUserManagementApiModule,
		ArchivingUsageAdminApiModule,
		ArchivingUsageApiModule,
		AuditEventApiModule,
		EricAdminApiModule,
		EricApiModule,
		ExportApiModule,
		FiskalTssLogAdminApiModule,
		FiskalTssLogExportApiModule,
		ImportApiModule,
		ManagementAdminApiModule,
		ManagementApiModule,
		NotificationAdminApiModule,
		NotificationApiModule,
		SelfcareApiModule,
		StatisticsApiModule,
		UserManagementApiModule,
		UsageApiModule,
		// Angular
		BrowserAnimationsModule,
		BrowserModule,
		// App
		AppRoutingModule, // must be imported before RootStoreModule
		// Shared
		SharedModule,
		// Third Party
		EffectsModule.forRoot( [] ),
		StoreModule.forRoot( {} ),
		LoggerModule.forRoot( { level: NgxLoggerLevel.OFF } ),
		NgbModule,
		ToastrModule.forRoot(),
		TranslateModule.forRoot( {
			loader: {
				deps: [ HttpClient ],
				provide: TranslateLoader,
				useFactory: createTranslateLoader
			},
			missingTranslationHandler: { provide: MissingTranslationHandler, useClass: TranslationHelperService }
		} ),
		KeycloakAngularModule,
		MatomoModule.forRoot( {
			disabled: !ANALYTICS_CONFIG?.featureEnabled,
			// requireConsent: ANALYTICS_CONFIG?.consentMode,
			scriptUrl: `${ MATOMO_TRACKER_URL_BY_ENVIRONMENT }matomo.js`,
			siteId: '1',
			trackerUrl: MATOMO_TRACKER_URL_BY_ENVIRONMENT
		} ),
		// MatomoRouterModule.forRoot({  // this makes default send with non-anonymized URL, but it's not needed
		// 	interceptors: [MatomoRouteDataInterceptor],
		// }),
		// keep this as last
		environment?.devModules
	], providers: [
		// Angular
		{
			provide: APP_INITIALIZER,
			useFactory: KeycloakUtils.initializer,
			multi: true,
			deps: [ KeycloakService ]
		},
		// Third Party
		// OpenApi
		{
			provide: BASE_PATH_ADMIN_MANAGEMENT, useValue: APP_CONFIG.baseUrl + '/api/management'
		},
		{
			provide: BASE_PATH_ADMIN_USAGE, useValue: APP_CONFIG.baseUrl + '/api/report'
		},
		{
			provide: BASE_PATH_ARCHIVING, useValue: APP_CONFIG.baseUrl + '/archiving-api'
		},
		{
			provide: BASE_PATH_ARCHIVING_EXPORT, useValue: APP_CONFIG.baseUrl + '/archiving-export-api'
		},
		{
			provide: BASE_PATH_ARCHIVING_USAGE_ADMIN, useValue: APP_CONFIG.baseUrl + '/archiving-report'
		},
		{
			provide: BASE_PATH_ARCHIVING_USAGE, useValue: APP_CONFIG.baseUrl + '/archiving-report'
		},
		{
			provide: BASE_PATH_ARCHIVING_USER_MANAGEMENT, useValue: APP_CONFIG.baseUrl + '/api/user-management'
		},
		{
			provide: BASE_PATH_AUDIT_EVENT, useValue: APP_CONFIG.baseUrl + '/api/audit-event'
		},
		{
			provide: BASE_PATH_ERIC, useValue: APP_CONFIG.baseUrl + '/api/eric'
		},
		{
			provide: BASE_PATH_ERIC_ADMIN, useValue: APP_CONFIG.baseUrl + '/api/eric'
		},
		{
			provide: BASE_PATH_EXPORT, useValue: APP_CONFIG.baseUrl + '/api/export'
		},
		{
			provide: BASE_PATH_FISKAL_ADMIN, useValue: APP_CONFIG.baseUrl + '/api/tsslog'
		},
		{
			provide: BASE_PATH_FISKAL_EXPORT, useValue: APP_CONFIG.baseUrl + '/api/tsslog'
		},
		{
			provide: BASE_PATH_IMPORT, useValue: APP_CONFIG.baseUrl + '/api/import'
		},
		{
			provide: BASE_PATH_MANAGEMENT, useValue: APP_CONFIG.baseUrl + '/api/management'
		},
		{
			provide: BASE_PATH_NOTIFICATION_ADMIN, useValue: APP_CONFIG.baseUrl + '/api/notification'
		},
		{
			provide: BASE_PATH_NOTIFICATION, useValue: APP_CONFIG.baseUrl + '/api/notification'
		},
		{
			provide: BASE_PATH_STATISTICS, useValue: APP_CONFIG.baseUrl + '/api/statistics'
		},
		{
			provide: BASE_PATH_SELFCARE, useValue: APP_CONFIG.baseUrl + '/api/selfcare'
		},
		{
			provide: BASE_PATH_USER_MANAGEMENT, useValue: APP_CONFIG.baseUrl + '/api/user-management'
		},
		{
			provide: BASE_PATH_USER_MANAGEMENT_ADMIN, useValue: APP_CONFIG.baseUrl + '/api/user-management'
		},
		{
			provide: BASE_PATH_USAGE, useValue: APP_CONFIG.baseUrl + '/api/report'
		},
		provideHttpClient( withInterceptorsFromDi() )
	]
} )

export class AppModule {}
